import { useTranslation } from 'react-i18next';
import { rangeDays, REPORT_RANGES, type ReportRange } from './reportRange';

type RangeChipsProps = {
  value: ReportRange;
  onChange: (range: ReportRange) => void;
};

/** Design HTML `chip()` — 9px radius, accent border when selected. */
export function RangeChips({ value, onChange }: RangeChipsProps) {
  const { t } = useTranslation('reports');
  return (
    <div className="flex flex-wrap gap-2">
      {REPORT_RANGES.map((range) => {
        const on = range === value;
        return (
          <button
            key={range}
            type="button"
            onClick={() => onChange(range)}
            className="rounded-[9px] px-[15px] py-[9px] text-[13.5px] font-semibold"
            style={{
              color: on ? 'var(--gs-ink)' : 'var(--gs-muted)',
              background: on ? 'var(--gs-panel2)' : 'transparent',
              border: `1px solid ${on ? 'var(--gs-accent)' : 'var(--gs-line)'}`,
              fontFamily: 'inherit',
              cursor: 'pointer',
            }}
          >
            {range === 'Today'
              ? t('ranges.today')
              : t('ranges.days', { count: rangeDays(range) })}
          </button>
        );
      })}
    </div>
  );
}
